<template>
    <div id="top_bar" >
        <div class="top-bar-wrapper">
            
            <!-- Top Bar Left -->
            <div class="bar-left-wrapper">
               <div class=" bard-logo">
                  <h1>
                        <a href="/">
                           bard.
                        </a>
                  </h1>
               </div>

               <!-- <notes-dropdown>
                  <img src="../../assets/img/toolbox/ft-editors-note.svg">
               </notes-dropdown>

               <review-dropdown>
                  <review-icon :color="'#fff'"></review-icon>
               </review-dropdown>

               <message-dropdown>
                  <img src="../../assets/img/manage/bttn-profile-comments-off.svg">
               </message-dropdown> -->

               <div class="user-wrapper" @click="handleLogout">
                  <user-avatar :dim="28" :circle="true"></user-avatar>
                  <div class="logout">Log Out</div>
               </div>
            </div>

            <div class="selections" v-if="create">
                <div class="btn-group" role="group" ref="dropdown_container" aria-label="Select your channel then select your template">
                    <channel-list></channel-list>
                    <template-list>SELECT A TEMPLATE </template-list>
                </div>
            </div>

            <div class="menu-wrapper" v-if="!home">
               <div @click="$emit('navigatingAway', 'create.html')" title="Create" :class="{active: isActive('create')}" class="menu-icon create"></div>
				   <div @click="$emit('navigatingAway', 'schedule.html')" title="Schedule" :class="{active: isActive('schedule')}" class="menu-icon schedule"></div>
               <div @click="$emit('navigatingAway', 'media_library.html')" :class="{active: isActive('media_library')}" class="menu-icon media-library" title="Media Library"></div>
				   <!-- <router-link :to="{ name: 'manage'}" title="Manage" class="menu-icon manage"></router-link> -->
                <!-- <a href="javascript:void(0);" onclick='showManage();' class="menu-icon event-calendar" title="Event Calendar"></a> -->
            </div>

        </div>
    </div>
</template>

<script>

// import NotesDropdown from './../components/nav/NotesDropdown';
// import ReviewDropdown from './../components/nav/ReviewDropdown';
// import MessageDropdown from './../components/nav/MessageDropdown';

import ChannelList from '@/create/components/ChannelList';
import TemplateList from '@/create/components/TemplateList';

import { mapState, mapActions } from 'vuex';

export default {
   name: 'TopBar',
   data: function() {
      return {
         selectedChanId: "",
         showNotesDropdown: false,
         showReviewDropdown: false,

         newReviewCount: 0,
         newNotesCount: 0,

         notes: [],
         reviews: [] ,
         userRole: 0
      }
   },
   props: {
       create: false,
       home: Boolean
   },
   methods: {
      ...mapActions('global', [
         'logout'
      ]),

      hide() {
         this.showNotesDropdown = false;
         this.showReviewDropdown = false;
      },

      handleLogout() {
         // localStorage.setItem('token', '');
         // window.location.href = window.location.origin + '/login.html';
         this.logout({vm:this});
      },

      isActive(page) {
         return (window.location.href.includes(page));
      },

      // handleNotesClick() {
      //    this.showNotesDropdown = !this.showNotesDropdown;
      //    if (this.showNotesDropdown) {
      //       this.getNotes();
      //    }
      // },

      // handleReviewsClick() {
      //    this.showReviewDropdown = !this.showReviewDropdown;
      //    if (this.showReviewDropdown) {
      //       this.getReviews();
      //    } else {
      //       this.markReviewsRead();
      //       this.getReviews();
      //    }
      // },

      // getNotes() {
      //    let self = this;
      //    $.post(
      //       this.BARD_HOST + '/user/my_notes',
      //       {
      //          'token'      : localStorage.getItem('token'),
      //          'filterOutLoggedInUserActions' : true
      //       }, function(data) {
      //          if (!data.error) {
      //             self.notes = data;
      //             self.newNotesCount = 0;
      //             for (let note of self.notes) {
      //                if (note.viewed == 0) {
      //                   self.newNotesCount++;
      //                }
      //             }
      //          } else {
      //             self.handleFailedAPICall('/note/user', 'TopBar', data);
      //          }
      //       }
      //    ).fail(function(e) {
      //       console.log("Error with /note/user: " + e.responseText);
      //    }); 
      // },

      // getReviews() {
      //    let self = this;
      //    $.post(
      //       this.BARD_HOST + '/user/review_activities',
      //       {
      //          'token'      : localStorage.getItem('token'),
      //          'limit'      : 10,
      //          'toReview'   : true //we're only grabbing stage events from other users and responses
      //       }, function(data) {
      //          if (!data.error) {
      //             self.reviews = data;
      //             self.newReviewCount = 0;
      //             for (let review of self.reviews) {
      //                if (review.viewed == 0) {
      //                   self.newReviewCount++;
      //                }
      //             }
      //          } else {
      //             self.handleFailedAPICall('/user/review_activities', 'TopBar', data);
      //          }
      //       }
      //    ).fail(function(e) {
      //       console.log("Error with /user/review_activities: " + e.responseText);
      //    });
      // },

      // markReviewsRead() {
      //    $.post(
      //       this.BARD_HOST + '/user/mark_reviews',
      //       {
      //          'token'      : localStorage.getItem('token'),
      //       }, function(data) {
      //          if (!data.error) {
      //          } else {
      //             self.handleFailedAPICall('/user/mark_reviews', 'TopBar', data);
      //          }
      //       }
      //    ).fail(function(e) {
      //       console.log("Error with /user/mark_reviews: " + e.responseText);
      //    }); 
      // }
   },
   created(){
      let self = this;
       this.$on('ChannelSelected', channelId => {
           self.selectedChanId = channelId;
       });

      // $.post(
      //    this.BARD_HOST + '/user/role',
      //    {
      //       'token'      : localStorage.getItem('token')
      //    },
      //    function(data) {
      //       if (!data.error) {
      //          self.userRole = data.roleId;
      //       } else {
      //          self.handleFailedAPICall('/instance/list', 'Create', data);
      //       }
      //    }
      // ).fail(function(e) {
      //    console.log("There was an error on the /instance/list call. " + e.responseText);
      // });

      // this.getNotes();
      // this.getReviews();
   },

   components: {
      // NotesDropdown,
      // ReviewDropdown,
      // MessageDropdown,

      ChannelList,
      TemplateList
   }
}
</script>

<style lang="scss" scoped>
#top_bar {
	height: 71px;
	width: 100vw;
	max-width: 100%;
	background-color: $bard-blue;
	color: white;
	border-bottom: 2px solid white;
   padding-left: 15px;
   padding-right: 15px;

	// @media only screen and (max-width: 1919px) {
	//   width: 1500px;
	// }

   .top-bar-wrapper {
      position: relative;
      width: 100%;
      display: flex;
      justify-content: space-between;
      height: 100%;
      align-items: center;
   }

   .bar-left-wrapper {
      display: flex;
      justify-content: flex-start;
      align-items: center;

      > div {
         flex-grow: 1;
         flex-shrink: 0;
         // padding: 0 8px;
         padding: 0 .5rem;
      }
   }

   .bard-logo {
      margin-top: .6em;
      h1 {
         margin-bottom: 0;
         font-size: 24px;
         font-size: 1.5rem;
         font-weight: 500;
         color: white;
         
         a {
            color: inherit;
         }
      }
   }

	.selections {
		// margin-top: 1.3em;
      margin-top: .5rem;
		font-size: 14px;
      min-width: 530px;
      position: absolute;
      left: 25%;

		.dropdown {
			display: inline-block;
		}
	}

   .user-wrapper {
      display: flex;
      align-items: center;
      border: 1px solid $bard-gold;
      padding: 4px 12px !important;
      color: $bard-gold;
      &:hover {
         background: $bard-gold;
         color: white;
         cursor: pointer;
      }

      .logout {
         text-transform: uppercase;
         margin-left: 10px;
         font-size: 14px;
         font-family: "Roboto Bold", sans-serif;
      }
   }

   .menu-wrapper {
	   padding-bottom: 9px;
	   padding-right: 15px;

		.menu-icon {
			display: inline-block;
			position: relative;
			width: 40px;
			height: 48px;
			margin-left: 35px; 
			vertical-align: middle;
			background-repeat: no-repeat; 
			background-position: center bottom; 
			background-size: 85%;
			transition: initial;

         &:hover {
            cursor: pointer;
         }

			&:focus {
				outline: none
			}

			&::after,
			&.active::after {
				content: ''; 
				position: absolute;
				left: 0;
				right: 0;
				bottom: -17px; 
				height: 6px;
				opacity: 0;
				background-color: $bard-gold;
			}

			&:hover::after,
			&:focus::after,
			&.active::after {
				opacity: 1;
			}

			&:first-of-type {
				margin-left: 0;
			}

			&.create {
				background-image: url('../assets/img/global/SVGs/BTTN_create_icon_OFF.svg'); 
				// background-size: 37px 42px;

				&:hover,
				&:focus,
				&.active {
					background-image: url('../assets/img/global/SVGs/BTTN_create_icon_ON.svg'); 
				}
			}

			&.schedule {
				background-image: url('../assets/img/global/SVGs/BTTN_schedule_icon_OFF.svg'); 
				// background-size: 37px 42px;

				&:hover,
				&:focus,
				&.active {
					background-image: url('../assets/img/global/SVGs/BTTN_schedule_icon_ON.svg'); 
				}
			}

			&.media-library {
				background-image: url('../assets/img/global/SVGs/BTTN_media_library_icon_OFF.svg');
				// background-size: 39px 44px;

				&:hover,
				&:focus,
				&.active {
					background-image: url('../assets/img/global/SVGs/BTTN_media_library_icon_ON.svg'); 
				}
			}

			&.manage {
				background-image: url('../assets/img/global/SVGs/BTTN_manage_icon_OFF.svg');
				// background-size: 39px 44px;

				&:hover,
				&:focus,
				&.active {
					background-image: url('../assets/img/global/SVGs/BTTN_manage_icon_ON.svg'); 
				}
			}

			&.event-calendar {
				background-image: url('../assets/img/global/SVGs/BTTN_event_icon_OFF.svg');
				// background-size: 38px 39px;

				&:hover,
				&:focus,
				&.active {
					background-image: url('../assets/img/global/SVGs/BTTN_event_icon_ON.svg'); 
				}
			}
		}
	}
}

.dropdown-content {
   margin-top: 19px;
   position: absolute;
   max-height: 600px;
   overflow-y:scroll;
   width: 500px;
   z-index: 30;
   padding: 0;
   border-radius: 0;
   background: $bard-blue;
   white-space: nowrap;

   a {
      color: white;
      padding: 2px 40px 2px 20px;
      text-decoration: none;
      display: block;

      &.new {
         background: rgba(94, 105, 129, 0.95);
      }

      &:not(:last-child) {
         border-bottom: .5px solid white;
      }
   }
}


</style>
